import { render, staticRenderFns } from "./relations.vue?vue&type=template&id=13882d4e&scoped=true"
import script from "./relations.vue?vue&type=script&lang=js"
export * from "./relations.vue?vue&type=script&lang=js"
import style0 from "./relations.vue?vue&type=style&index=0&id=13882d4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13882d4e",
  null
  
)

export default component.exports